import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    hidden: true,
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login/index.vue')
  },
  {
    path: '/404',
    component: () => import('../views/Login/index.vue'),
    hidden: true
  },
  {
    // 将匹配所有内容并将其放在 `$route.params.pathMatch` 下
    path: '/:pathMatch(.*)*',
    redirect: '/login',
    component: () => import('@/views/Login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    name: 'BasicLayout',
    redirect: '/workplace',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: 'workplace',
        name: 'workPlace',
        component: () => import('../views/WorkPlace/index.vue')
      },
      {
        path: 'todo',
        name: 'todo',
        component: () => import('../views/Todo/index.vue')
      },
      {
        path: 'satisfaction',
        name: 'Satisfaction',
        component: () => import('../views/Satisfaction/index.vue')
      },
      {
        path: 'helper',
        name: 'helper',
        component: () => import('../views/UserPool/helper')
      },
      {
        path: 'doctor',
        name: 'doctor',
        component: () => import('../views/UserPool/doctor')
      },
      {
        path: 'activeRevisit',
        name: 'activeRevisit',
        component: () => import('../views/UserPool/activeRevisit/index.vue')
      },
      {
        path: 'patient',
        name: 'patient',
        component: () => import('../views/UserPool/patient')
      },
      // {
      //   path: 'activity',
      //   name: 'Activity',
      //   component: () => import('../views/Activity/index.vue')
      // },
      {
        path: 'checklist',
        name: 'Checklist',
        component: () => import('../views/HealthRecord/index.vue')
      },
      {
        path: 'formEdit',
        name: 'formEdit',
        component: () => import('../views/HealthRecord/formEdit.vue')
      },
      {
        path: 'healthInfo',
        name: 'HealthInfo',
        component: () => import('../views/HealthRecord/HealthInfo/index.vue')
      },
      {
        path: 'speech',
        name: 'Speech',
        component: () => import('../views/Speech/index.vue')
      },
      {
        path: 'performanceData',
        name: 'PerformanceData',
        component: () => import('../views/DataCenter/performanceData/index.vue')
      },
      {
        path: 'salesData',
        name: 'salesData',
        component: () => import('../views/DataCenter/salesData/index.vue')
      },
      {
        path: 'callLog',
        name: 'callLog',
        component: () => import('../views/CallLog/index.vue')
      },
      {
        path: 'SMSLog',
        name: 'SMSLog',
        component: () => import('../views/SMSLog/index.vue')
      },
      {
        path: 'alarmReminder',
        name: 'alarmReminder',
        component: () => import('../views/AlarmReminder/index.vue')
      },
      {
        path: 'excellentCase',
        name: 'excellentCase',
        component: () => import('../views/ExcellentCase/index.vue')
      },
      {
        path: 'bdWorkorder',
        name: 'bdWorkorder',
        component: () => import('../views/bdWorkorder')
      },
      {
        path: 'preliminaryMedicalRecord',
        name: 'preliminaryMedicalRecord',
        component: () => import('../views/PreMedicalRecord/index.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
